import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/es/symbol';
import 'core-js/features/symbol/iterator';
import 'normalize.css';
import 'react-select/dist/react-select.min.css';
import './styles/styles.css'; // This file is generated by compiling less. Modifying is meaningless.
import App from './App';

ReactDOM.render(<App/>, document.getElementById('root'));
